import React, { Suspense } from "react";
import { Route } from "react-router-dom";
import Loading from '../../components/common/Loading';
import "../home/Home.css";

const Guest = (props) => {
  return (
    <div className="homeWrapper">
      <div className="homeContainer">
        <div className="homeColG homeCol2responsive overflowFlexBox">
          <Suspense fallback={<Loading />}>
            <Route
              key='confchild'
              exact
              path={props.path}
              {...props}
              component={props.component}
            />
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default Guest;